// src/routes/ProtectedAdminRoute.jsx
import { Navigate } from "react-router-dom";
import { useIsAdmin } from "../hooks/useIsAdmin";

export default function ProtectedAdminRoute({ children }) {
  const { isAdmin, loading } = useIsAdmin();
  if (loading) return null;           // или спиннер
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}
